import { render, staticRenderFns } from "./campaignTab.vue?vue&type=template&id=dc9ba17e&lang=pug"
import script from "./campaignTab.vue?vue&type=script&lang=js"
export * from "./campaignTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports